export class Ajax {
    static request(url, method, data) {
        const request = new XMLHttpRequest();
        return new Promise(function (resolve, reject) {
            // Setup our listener to process compeleted requests
            request.onreadystatechange = function () {
                // Only run if the request is complete
                if (request.readyState !== 4)
                    return;
                // Process the response
                if (request.status >= 200 && request.status < 300) {
                    // If successful
                    resolve(request);
                }
                else {
                    // If failed
                    reject({
                        status: request.status,
                        statusText: request.statusText,
                    });
                }
            };
            // Setup our HTTP request
            request.open(method || 'GET', url, true);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            // Send the request
            request.send(JSON.stringify(data) || null);
        });
    }
    /**
     * Performs a GET-request
     * @param url
     * @returns {Promise}
     */
    static get(url) {
        return Ajax.request(url, 'GET');
    }
    /**
     * Performs a POST-request
     * @param url
     * @param data
     * @returns {Promise}
     */
    static post(url, data) {
        return Ajax.request(url, 'POST', data);
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    static buildURLQuery(objects) {
        return Object.entries(objects).
            map(pair => pair.map(encodeURIComponent).join('=')).
            join('&');
    }
    static appendURLQueryToURL(url, query) {
        let ampOrQuestion = '?';
        if (url.search(/\?/) !== -1) {
            ampOrQuestion = '&';
        }
        return url + ampOrQuestion + query;
    }
}
export default Ajax;
